<template>
  <div>
    <div class="bg-white text-black text-sm font-bold py-2 px-3 rounded flex items-center">
      <input type="text" aria-label="Cari sekolah" placeholder="Cari sekolah..." v-model="keywords" class="bg-white outline-none mr-1 w-full" @keyup="onKeyup" @keydown.down="onArrowDown" @keydown.up="onArrowUp" @keydown.enter="onEnter" @input="onChange">
      <div>
        <v-icon v-if="isSearching" scale="0.7" name="spinner" pulse class="text-button-icon" />
        <v-icon v-else scale="0.7" name="search" class="text-button-icon" />
      </div>
    </div>
    <div v-if="isOpen && keywords.length >= 3 && !isSearching" class="absolute mt-1 bg-white-90 w-64">
      <div v-if="isSearchResultAvailable" ref="results">
        <div :tabindex="index" v-for="(item, index) in searchResults" :key="index" class="result text-sm hover:bg-grey-lighter-85 cursor-pointer px-3 border-b border-grey-light py-1.5" :class="{ active: index === arrowCounter }" @click="onClick(item)">
          {{ item.properties.nama }}
        </div>
      </div>
      <div v-else class="text-grey-darkest text-sm px-3 py-1.5 italic">
        :(
        <br>
        Data tidak ditemukan.
        <br>
        Coba "SMAN 8 Jakarta".
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce'

export default {
  name: 'search',
  props: {
    isSearching: Boolean,
    search: Function,
    isSearchResultAvailable: Boolean,
    searchResults: Array,
    resultSelected: Function
  },
  data () {
    return {
      isOpen: true,
      arrowCounter: -1,
      keywords: ''
    }
  },
  methods: {
    onKeyup: debounce(async function (e) {
      let key = e.key
      let allowdKeyCodes = [
        'ArrowUp',
        'ArrowDown',
        'ArrowRight',
        'ArrowLeft',
        'Enter',
        'Escape',
        'Home',
        'PageUp',
        'PageDown',
        'End',
        'Shift',
        'Control',
        'Alt',
        'CapsLock',
        'ContextMenu'
      ]
      if (!allowdKeyCodes.includes(key)) {
        this.keywords = e.target.value
        if (this.keywords.length >= 3) {
          this.search(this.keywords)
        }
      }
    }, 600),
    onChange () {
      this.isOpen = true
    },
    onArrowDown () {
      if (this.arrowCounter < this.searchResults.length - 1) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    onArrowUp () {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    onEnter () {
      this.isOpen = false
      this.keywords = ''
      this.resultSelected(this.searchResults[this.arrowCounter])
      this.arrowCounter = -1
    },
    onClick (item) {
      this.isOpen = false
      this.keywords = ''
      this.resultSelected(item)
    }
  }
}
</script>

<style scoped>
@tailwind preflight;

.result.active {
  @apply bg-grey-lighter-85
}

@tailwind utilities;
</style>
